import React from 'react';
import { Box, Typography, Paper, Grid, TextField } from '@mui/material';

export default function SimDetails({ 
    formData, 
    handleInputChange, 
    RequiredLabel, 
    StandardLabel, 
    errors = {},
    t 
}) {
    // console.log(formData)
    return (
        <Box
            sx={{
                padding: { xs: '20px', md: '40px' },
                margin: { xs: '0px 20px', md: '0px 40px' },
                backgroundColor: '#FFFFFF',
                border: '1px solid #A5DCF3',
                borderRadius: '10px',
                boxShadow: '-2px 2px 5px 0px #00000040',
                mb: 3,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Paper
                    sx={{
                        height: 52,
                        width: '100%',
                        borderRadius: '8px',
                        padding: '12px 24px',
                        backgroundColor: '#647490',
                        boxShadow: '-2px 2px 5px 0px #00000040',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        color="white"
                        sx={{ fontSize: { xs: '18px', md: '20px' } }}
                    >
                        {t('SIM Card Details')}
                    </Typography>
                </Paper>
            </Box>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} mb={1}>
                                <StandardLabel label={t('Mobile Number')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type Mobile Number')}
                                    value={formData.simCard?.mobileNumber || ''}
                                    onChange={(e) => handleInputChange(e, 'simCard.mobileNumber')}
                                    error={!!errors.mobileNumber}
                                    helperText={errors.mobileNumber}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.mobileNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.mobileNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.mobileNumber ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('SIM IMEI Number')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type SIM IMEI')}
                                    value={formData.simCard?.simImei || ''}
                                    onChange={(e) => handleInputChange(e, 'simCard.simImei')}
                                    error={!!errors.simImei}
                                    helperText={errors.simImei}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.simImei ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.simImei ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.simImei ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} 
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Next Recharge Date')} />
                                <TextField
                                    fullWidth
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    value={formData.simCard?.nextRechargeDate || ''}
                                    onChange={(e) => handleInputChange(e, 'simCard.nextRechargeDate')}
                                    error={!!errors.nextRechargeDate}
                                    helperText={errors.nextRechargeDate}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: errors.nextRechargeDate ? '2px solid #d32f2f' : '2px solid #183059',
                                            '&:hover': {
                                                border: errors.nextRechargeDate ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: errors.nextRechargeDate ? '2px solid #d32f2f' : '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} 
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} mb={1.5}>
                                <StandardLabel label={t('Provider')} />
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: false }}
                                    placeholder={t('Type Provider')}
                                    value={formData.simCard?.provider || ''}
                                    onChange={(e) => handleInputChange(e, 'simCard.provider')}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: "55px",
                                            borderRadius: '16px',
                                            padding: '16px 24px',
                                            border: '2px solid #183059',
                                            '&:hover': {
                                                border: '2px solid #183059',
                                            },
                                            '&.Mui-focused': {
                                                border: '2px solid #183059',
                                            },
                                            '& fieldset': {
                                                border: 'none !important',
                                            },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: 0,
                                        },
                                    }} 
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}